// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1oH8R","sendOtp":"AuthorizeToLogin_sendOtp__1BDN9"};